<div class="p-8 bg-gray-100 min-h-screen">
    <h2 class="text-2xl font-bold text-gray-800 mb-8">Types de biens</h2>
  
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      
      <!-- Formulaire d'ajout -->
      <div class="bg-white p-6 rounded-lg shadow">
        <h3 class="text-lg font-semibold mb-4">Nouveau type</h3>
  
        <label class="block text-sm font-medium text-gray-700 mb-2" for="libelle">Libellé</label>
        <input
          type="text"
          [(ngModel)]="newPropertyType.typeName"
          placeholder="Ex: Appartement"
          id="typeName"
          name="typeName"
          required
          minlength="2"
          maxlength="50"    
         pattern="^[a-zA-Z0-9À-ÿ\s-]+$"
          class="w-full px-4 py-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 mb-4"
        />
  
        <button
          (click)="addPropertyType()"
          class="w-full bg-orange-500 hover:bg-orange-600 text-white py-2 rounded-md font-semibold transition duration-200"
        >
          Ajouter
        </button>
      </div>
  
      <!-- Liste des types -->
      <div class="bg-white p-6 rounded-lg shadow">
        <h3 class="text-lg font-semibold mb-4">Liste des types</h3>
  
        <ul class="divide-y divide-gray-200">
          <li
            *ngFor="let type of propertyTypes"
            class="flex justify-between items-center py-3"
          >
            <span class="text-gray-800 font-medium">{{ type.typeName }}</span>
  
            <div class="flex items-center gap-3">
              <button
                (click)="editPropertyType(type)"
                class="bg-yellow-100 text-yellow-600 p-2 rounded-full hover:bg-yellow-200"
                title="Modifier"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
              </button>
  
              <button
                (click)="deletePropertyType(type.id ?? 0)"
                class="bg-red-100 text-red-600 p-2 rounded-full hover:bg-red-200"
                title="Supprimer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  